import { el } from '../dom.js';

/**
 * Base modal overlay — a centered card over a click-blocking backdrop, with a
 * title bar and close button. Subclasses populate `this.body`. Shown over the
 * active screen (start or paused) and closed via the ✕, backdrop click, or Esc.
 */
export default class Overlay {
  constructor({ title, onClose }) {
    this.onClose = onClose;

    this.el = el('div', 'overlay is-hidden');

    const backdrop = el('div', 'overlay-backdrop');
    backdrop.addEventListener('click', () => this.onClose?.());
    this.el.appendChild(backdrop);

    const card = el('div', 'overlay-card');
    const header = el('div', 'overlay-header');
    header.appendChild(el('span', 'overlay-title', title));
    const close = el('button', 'overlay-close', '✕');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.addEventListener('click', () => this.onClose?.());
    header.appendChild(close);
    card.appendChild(header);

    this.body = el('div', 'overlay-body');
    card.appendChild(this.body);

    this.el.appendChild(card);
  }

  setVisible(v) { this.el.classList.toggle('is-hidden', !v); }
}
